import { Component } from '@angular/core';
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from '../../services/user.service';
import { ViewportService } from '../../services/viewport.service';

/**
 * Provides a view of a video product.
 */
@Component({
	selector: 'doc-video-view',
	templateUrl: './doc-video-view.component.html',
	styleUrl: './doc-video-view.component.css'
})
export class DocVideoViewComponent implements OnInit {

	@Input() product!: any;
	@Input() viewerURL: SafeResourceUrl | undefined;
	@Input() viewerOverviewURL: SafeResourceUrl | undefined;
	@Input() downloadDocumentLink!: string | null;
	@Input() downloadDocumentPageLink!: string | null;
	@Input() pages!: any[];

	LOCALIZATION: any;
	
	isMobile: boolean = false;
	panelOn: boolean = false;

	videoclip: { begin: number; end: number; videoDuration: number; } = {
		begin: 0,
		end: 0,
		videoDuration: 0
	};

	constructor(
		private userService: UserService,
		private viewportService: ViewportService
	) {
		// Replacement for the viewportsizemonitor directive
		this.viewportService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
				
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	ngOnInit(): void {
		this.loadDocument();
	}
	
	/**
	 * Reinitialize this component without destroying the DOM.
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes['viewerURL'] || changes['product']) {
			this.loadDocument();
		}
	}

	private loadDocument(): void {
		this.videoclip = {
			begin: 0,
			end: 0,
			videoDuration: 0
		};
	}

	performClip(): void {
		if (this.videoclip.begin >= 0 && this.videoclip.end <= this.videoclip.videoDuration) {
			let clipDetails = {
				isPixelCoords: true,
				minX: this.videoclip.begin,
				minY: 0,
				maxX: this.videoclip.end,
				maxY: 0
			};
			if (this.pages.length > 0) {
				let download = window.open(this.downloadDocumentPageLink + "?videoClipDetails=" + encodeURIComponent(JSON.stringify(clipDetails)), '_blank')
			} else {
				let download = window.open(this.downloadDocumentLink + "?videoClipDetails=" + encodeURIComponent(JSON.stringify(clipDetails)), '_blank')
			}
		}
	}
}
